export function isNeedToShowBuildingItemIcons({ isArchived, isHovered }) {
  return isArchived || isHovered
}
